import beachImage from "../assets/images/unity-loading/beach.jpg";
import campsiteImage from "../assets/images/unity-loading/campsite.jpg";
import forestImage from "../assets/images/unity-loading/forest.jpg";
import parkImage from "../assets/images/unity-loading/park.jpg";
import winterHolidayImage from "../assets/images/unity-loading/winter-holiday.jpg";

const UNITY_ROOM_LOADING_IMAGES = {
  beach: beachImage,
  "beach-therapy": beachImage,
  demo: beachImage,
  campsite: campsiteImage,
  "campsite-therapy": campsiteImage,
  forest: forestImage,
  mountain: forestImage,
  "forest-therapy": forestImage,
  park: parkImage,
  "park-therapy": parkImage,
  winterHoliday: winterHolidayImage,
  "winter-holiday": winterHolidayImage,
};

const UNITY_ROOM_LOADING_TITLES = {
  beach: "Therapy Beach Office",
  "beach-therapy": "Therapy Beach Office",
  demo: "Therapy Beach Office",
  campsite: "Therapy Campfire",
  "campsite-therapy": "Therapy Campfire",
  forest: "Therapy Forest Office",
  mountain: "Therapy Forest Office",
  "forest-therapy": "Therapy Forest Office",
  park: "Therapy Quiet Park",
  "park-therapy": "Therapy Quiet Park",
  winterHoliday: "Therapy Winter Cabin",
  "winter-holiday": "Therapy Winter Cabin",
};

const retainedImages = new Map();
let preloadPromise;

export function getUnityRoomLoadingImage(roomType) {
  return UNITY_ROOM_LOADING_IMAGES[roomType] || null;
}

export function getUnityRoomLoadingTitle(roomType) {
  return UNITY_ROOM_LOADING_TITLES[roomType] || "Loading Your Space";
}

function loadAndDecodeImage(src) {
  return new Promise((resolve) => {
    const image = new Image();
    retainedImages.set(src, image);
    let settled = false;
    const finish = async () => {
      if (settled) return;
      settled = true;
      clearTimeout(timeout);
      try {
        await image.decode?.();
      } catch {
        // A decoded image is preferred, but a downloaded image can still be
        // painted by the browser when the Unity route opens.
      }
      resolve();
    };
    image.onload = finish;
    image.onerror = finish;
    const timeout = setTimeout(finish, 8000);
    image.src = src;
    if (image.complete) void finish();
  });
}

export function preloadUnityRoomLoadingImages() {
  if (typeof Image === "undefined") return Promise.resolve();
  if (!preloadPromise) {
    preloadPromise = Promise.all(
      [...new Set(Object.values(UNITY_ROOM_LOADING_IMAGES))].map(loadAndDecodeImage)
    ).then(() => undefined);
  }
  return preloadPromise;
}
